import Modal from 'trunks/vue/admin/components/modals/modal.js';
import AccessModalModel from './access_modal_model.js';

export default Vue.extend({
  components: {
    modal: Modal,
    'access-modal-model': AccessModalModel,
  },

  template: `
    <modal title="新增角色" extendClass="create-new-access-modal" ref="modal">
      <access-modal-model :options="options"
                          @valueChange="valueChangeFunc"
                          ref="accessModalModelRef">
      </access-modal-model>
      <div slot='footer' class="modal-footer">
        <button class="outlined btn-default" @click='cancel'>取消</button>
        <button @click='save'>确定</button>
      </div>
    </modal>
  `,

  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    createSuccessedCallback: {
      type: Function,
    },
  },

  data() {
    return {
      access: null,
    };
  },

  methods: {
    validateAccessName() {
      this.accessNameErrorTip = !this.accessName;
    },

    validateAccessSelect() {
      this.accessSelectErrorTip = !this.selectedItems.length;
    },

    valueChangeFunc(access) {
      this.access = access;
    },

    save() {
      if (this.$refs.accessModalModelRef.validate()) {
        Skylark.Libs.Ajax.post('/admin/accesses', {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          data: {
            access: this.access,
          },
          success: (data) => {
            Skylark.Bridge.newAlertify('新增角色成功', {
              type: 'success',
            });
            this.cancel();
            this.createSuccessedCallback(data);
          },
          error() {
            Skylark.Bridge.newAlertify('新增角色失败，请重试', {
              type: 'error',
            });
          },
        });
      }
    },

    cancel() {
      this.$refs.modal.close();
    },
  },
});
